import { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import CategoryCard from "./CategoryCard";
import GalleryOverlay from "./GalleryOverlay";

export default function Portfolio() {
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const containerRef = useRef(null);

    useEffect(() => {
        const context = require.context(
            "../../data/categories",
            false,
            /\.js$/
        );

        const loaded = context.keys().map((key) => {
            return context(key).default;
        });

        loaded.sort((a, b) => a.order - b.order);
        setCategories(loaded);
    }, []);

    const goTo = (index) => {
        if (!containerRef.current) return;

        const cards = containerRef.current.children;
        if (!cards[index]) return;

        cards[index].scrollIntoView({
            behavior: "smooth",
            inline: "start", // 👈 important
            block: "nearest",
        });

        setCurrentIndex(index);
    };

    const next = () => {
        if (currentIndex < categories.length - 1) {
            goTo(currentIndex + 1);
        }
    };

    const prev = () => {
        if (currentIndex > 0) {
            goTo(currentIndex - 1);
        }
    };

    return (
        <>
            <div className="h-full bg-neutral-950 text-white flex flex-col relative">

                {/* Header */}
                <div className="px-12 pt-16 pb-8">
                    <h2 className="text-4xl font-semibold tracking-tight">
                        Portfolio
                    </h2>
                </div>

                {/* Arrows */}
                {/* Arrows */}
                <button
                    onClick={prev}
                    disabled={currentIndex === 0}
                    className="absolute left-0 top-1/2 -translate-y-1/2
             px-1 z-20
             text-white
             hover:opacity-70
             transition-opacity duration-300
             disabled:opacity-20"
                >
                    <ChevronLeft
                        size={48}
                        strokeWidth={1.5}
                        className="scale-y-125"
                    />
                </button>

                <button
                    onClick={next}
                    disabled={currentIndex === categories.length - 1}
                    className="absolute right-0 top-1/2 -translate-y-1/2
             px-1 z-20
             text-white
             hover:opacity-70
             transition-opacity duration-300
             disabled:opacity-20"
                >
                    <ChevronRight size={58} strokeWidth={1.5} className="scale-y-125"/>
                </button>

                {/* Cards Container */}
                <div className="flex-1 flex items-center overflow-hidden">

                    <div
                        ref={containerRef}
                        className="flex gap-16 snap-x snap-mandatory
                                 overflow-x-auto scrollbar-hide
                                 px-10 scroll-px-10"
                    >
                        {categories.map((cat) => (
                            <div
                                key={cat.id}
                                className="snap-start shrink-0" // 👈 important
                            >
                                <CategoryCard
                                    category={cat}
                                    onClick={() => setActiveCategory(cat)}
                                />
                            </div>
                        ))}
                    </div>

                </div>
            </div>

            {activeCategory && (
                <GalleryOverlay
                    category={activeCategory}
                    onClose={() => setActiveCategory(null)}
                />
            )}
        </>
    );
}